import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api';

export const ALL_CIR_REQUEST = 'ALL_CIR_REQUEST';
export const ALL_CIR_SUCCESS = 'ALL_CIR_SUCCESS';
export const ALL_CIR_FAILURE = 'ALL_CIR_FAILURE';

export const ALL_CIR_LOOKUPS_REQUEST = 'ALL_CIR_LOOKUPS_REQUEST';
export const ALL_CIR_LOOKUPS_SUCCESS = 'ALL_CIR_LOOKUPS_SUCCESS';
export const ALL_CIR_LOOKUPS_FAILURE = 'ALL_CIR_LOOKUPS_FAILURE';

export const CIR_REQUEST = 'CIR_REQUEST';
export const CIR_SUCCESS = 'CIR_SUCCESS';
export const CIR_FAILURE = 'CIR_FAILURE';

export const CIR_SAVE_REQUEST = 'CIR_SAVE_REQUEST';
export const CIR_SAVE_SUCCESS = 'CIR_SAVE_SUCCESS';
export const CIR_SAVE_FAILURE = 'CIR_SAVE_FAILURE';

export const REPORT_UPLOAD_FILES_REQUEST = 'REPORT_UPLOAD_FILES_REQUEST';
export const REPORT_UPLOAD_FILES_SUCCESS = 'REPORT_UPLOAD_FILES_SUCCESS';
export const REPORT_UPLOAD_FILES_FAILURE = 'REPORT_UPLOAD_FILES_FAILURE';

export const HEALTH_TYPES_REQUEST = 'HEALTH_TYPES_REQUEST';
export const HEALTH_TYPES_SUCCESS = 'HEALTH_TYPES_SUCCESS';
export const HEALTH_TYPES_FAILURE = 'HEALTH_TYPES_FAILURE';

export const PATIENT_HEALTH_TYPES_REQUEST = 'PATIENT_HEALTH_TYPES_REQUEST';
export const PATIENT_HEALTH_TYPES_SUCCESS = 'PATIENT_HEALTH_TYPES_SUCCESS';
export const PATIENT_HEALTH_TYPES_FAILURE = 'PATIENT_HEALTH_TYPES_FAILURE';

export function requestCIReports(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/cir/search?${query}`,
      method: 'GET',
      types: ["ALL_CIR_REQUEST", "ALL_CIR_SUCCESS", "ALL_CIR_FAILURE"]
    },
  };
}

export function requestAllLookups(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/cir/lookups?${query}`,
      method: 'GET',
      types: ["ALL_CIR_LOOKUPS_REQUEST", "ALL_CIR_LOOKUPS_SUCCESS", "ALL_CIR_LOOKUPS_FAILURE"]
    },
  };
}

export function requestCIRReport(id, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/cir/reports/${id}?${query}`,
      method: 'GET',
      types: ["CIR_REQUEST", "CIR_SUCCESS", "CIR_FAILURE"]
    }
  }
}

export function saveCIRReport(report, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/cir/reports?${query}`,
      method: 'POST',
      body: JSON.stringify(report),
      types: ["CIR_SAVE_REQUEST", "CIR_SAVE_SUCCESS", "CIR_SAVE_FAILURE"]
    }
  }
}

export function saveCIRReportTasks(tasks, id, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/cir/reports/${id}/tasks?${query}`,
      method: 'POST',
      body: JSON.stringify(tasks),
      types: ["CIR_TASKS_SAVE_REQUEST", "CIR_TASKS_SAVE_SUCCESS", "CIR_TASKS_SAVE_FAILURE"]
    }
  }
}

export function deleteClientEscalation(escalationId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/escalation-manager/delete/${escalationId}?${query}`,
      method: 'PUT',
      body: JSON.stringify(escalationId),
      types: ["ESCALATION_DELETE_REQUEST", "ESCALATION_DELETE_SUCCESS", "ESCALATION_DELETE_FAILURE"]
    }
  }
}

export function requestGenders(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/cir/lookups/genders/all?${query}`,
      method: 'GET',
      types: ['GENDERS_REQUEST', 'GENDERS_SUCCESS', 'GENDERS_FAILURE',]
    }
  }
}

export function requestImpactedTypes(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/cir/lookups/impacted-types/all?${query}`,
      method: 'GET',
      types: ['IMPACTED_TYPES_REQUEST', 'IMPACTED_TYPES_SUCCESS', 'IMPACTED_TYPES_FAILURE',]
    }
  }
}

export function requestIncidentStatuses(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/cir/lookups/incident-statuses/all?${query}`,
      method: 'GET',
      types: ['STATUS_REQUEST', 'STATUS_SUCCESS', 'STATUS_FAILURE',]
    }
  }
}

export function requestTimeZones(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/lookups/timezones/all?${query}`,
      method: 'GET',
      types: ['TIMEZONES_REQUEST', 'TIMEZONES_SUCCESS', 'TIMEZONES_FAILURE',]
    }
  }
}

export function requestVisitorHealthTypes(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/cir/lookups/visitor-health-types?${query}`,
      method: 'GET',
      types: ['VISITOR_TYPES_REQUEST', 'VISITOR_TYPES_SUCCESS', 'VISITOR_TYPES_FAILURE',]
    }
  }
}

export function requestEmployeeHealthTypes(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/cir/lookups/employee-health-types?${query}`,
      method: 'GET',
      types: ['EMPLOYEE_TYPES_REQUEST', 'EMPLOYEE_TYPES_SUCCESS', 'EMPLOYEE_TYPES_FAILURE',]
    }
  }
}

export function requestPatientHealthTypes(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/cir/lookups/patient-health-types?${query}`,
      method: 'GET',
      types: ['HEALTH_TYPES_REQUEST', 'HEALTH_TYPES_SUCCESS', 'HEALTH_TYPES_FAILURE',]
    }
  }
}

export function requestPatientHealthTypesByParentId(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/cir/lookups/patient-health-types?${query}`,
      method: 'GET',
      types: ['PATIENT_HEALTH_TYPES_REQUEST', 'PATIENT_HEALTH_TYPES_SUCCESS', 'PATIENT_HEALTH_TYPES_FAILURE',]
    }
  }
}

export function requestHintLocationTypeahead(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/lookups/hint-locations/typeahead?${query}`,
      method: 'GET',
      types: ['HINT_LOCATIONS_REQUEST', 'HINT_LOCATIONS_SUCCESS', 'HINT_LOCATIONS_FAILURE',]
    }
  }
}

export function uploadCIReportFiles(id, params, htmlFiles = []) {
  const query = $.param(params);
  const data = new FormData();

  htmlFiles.forEach((file) => data.append('attach.file', file));
  htmlFiles.forEach((file) => data.append('attach.title', params.title));
  htmlFiles.forEach((file) => data.append('attach.description', params.description));
  
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/cir/reports/${id}/files?${query}`,
      method: 'POST',
      headers: {},
      body: data,
      types: ['REPORT_UPLOAD_FILES_REQUEST', 'REPORT_UPLOAD_FILES_SUCCESS', 'REPORT_UPLOAD_FILES_FAILURE']
    },
  };
}

export function downloadCIReportFile(id, params, fileName) {
  const query = $.param(params);

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/cir/reports/${id}/files/${fileName}/?${query}`,
      method: 'GET',
      headers: {},
      types: [
        'REPORT_DOWNLOAD_FILE_REQUEST',
        {
          type: 'REPORT_DOWNLOAD_FILE_SUCCESS',
          payload: (action, state, res) => {
            return res.blob();
          }
        },
        'REPORT_DOWNLOAD_FILE_FAILURE']
    },
  };
}

export function previewCIReportFile(id, params, fileName) {
  const query = $.param(params);

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/cir/reports/preview/${id}/files/${fileName}/?${query}`,
      method: 'GET',
      headers: {},
      types: [
        'REPORT_PREVIEW_FILE_REQUEST',
        {
          type: 'REPORT_PREVIEW_FILE_SUCCESS',
          payload: (action, state, res) => {
            return res.blob();
          },
        },
        'REPORT_PREVIEW_FILE_FAILURE']
    }
  };
}

export function deleteCIReportFile(reportId, fileName, params) {
  const query = $.param(params);

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/cir/reports/${reportId}/files/${fileName}/?${query}`,
      method: 'DELETE',
      types: ['REPORT_DELETE_FILE_REQUEST', 'REPORT_DELETE_FILE_SUCCESS', 'REPORT_DELETE_FILE_FAILURE']
    },
  };
}

export function addCIReportComment(message, params = {}) {
  const query = $.param(params);
  
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/cir/reports/${params.reportId}/comments?${query}`,
      method: 'POST',
      body: JSON.stringify(message),
      types: ["CIR_COMMENT_ADD_REQUEST", "CIR_COMMENT_ADD_SUCCESS", "CIR_COMMENT_ADD_FAILURE"]
    }
  }
}

export function updateCIReportComment(id, message, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/cir/reports/comments/${id}?${query}`,
      method: 'PUT',
      body: JSON.stringify(message),
      types: ["CIR_COMMENT_UPDATE_REQUEST", "CIR_COMMENT_UPDATE_SUCCESS", "CIR_COMMENT_UPDATE_FAILURE"]
    }
  }
}

export function deleteCIReportComment(id, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/cir/reports/comments/${id}?${query}`,
      method: 'DELETE',
      body: JSON.stringify(id),
      types: ["CIR_COMMENT_DELETE_REQUEST", "CIR_COMMENT_DELETE_SUCCESS", "CIR_COMMENT_DELETE_FAILURE"]
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/cir-manager/ClinicalIncidentActions.js